import { render, staticRenderFns } from "./ManageCertificates.vue?vue&type=template&id=509bb242&scoped=true&"
import script from "./ManageCertificates.vue?vue&type=script&lang=js&"
export * from "./ManageCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509bb242",
  null
  
)

export default component.exports